import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import { getLocalStorageItem, setLocalStorageItem } from 'hooks';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from 'routes/RouteConstants';

import Admin from '../../assets/Images/Admin.svg';
import SuperAdmin from '../../assets/Images/SuperAdmin.svg';

const RoleLogin = () => {
  const navigate = useNavigate();

  setLocalStorageItem('adminRoles', {
    isSuperAdmin: false,
    isAdmin: false,
  });

  function navigateToPage(roles: any) {
    const userActions = getLocalStorageItem('actionRequired');
    // console.log(roles, 'roles');
    if (userActions?.isPinSetupRequired) {
      navigate(routes.SET_NEW_PIN.pathname);
    } else if (userActions?.isTwoFactorRequired) {
      navigate(routes.VERIFY_OTP.pathname);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (roles.isSuperAdmin) {
        navigate(routes.MANAGE_CLINICS.pathname);
      } else if (roles.isAdmin) {
        navigate(routes.DASHBOARD.pathname);
      }
    }
  }

  function adminHandler() {
    const currentRoles = getLocalStorageItem('adminRoles') || {};
    currentRoles.isSuperAdmin = false;
    currentRoles.isAdmin = true;
    setLocalStorageItem('adminRoles', currentRoles);
    navigateToPage(currentRoles);
  }

  function superAdminHandler() {
    const currentRoles = getLocalStorageItem('adminRoles') || {};
    currentRoles.isSuperAdmin = true;
    currentRoles.isAdmin = false;
    setLocalStorageItem('adminRoles', currentRoles);
    navigateToPage(currentRoles);
  }

  const handleLogoutNavigate = () => {
    localStorage.clear();
    // setLocalStorageItem('i18nextLng', 'de');
    navigate(routes.LOGIN.pathname);
  };

  return (
    <div className="relative flex h-screen items-center justify-center">
      <div className="">
        <div className="m-auto flex items-center justify-center gap-x-52 ">
          <div>
            <div className="rounded-[50px] border border-solid border-gray-300 p-3 shadow-md">
              <img src={SuperAdmin} className="h-[180px] w-[180px]" />
            </div>
            <div className="m-auto mx-2 mt-4 flex items-center justify-center">
              <Button className="w-full text-xs" onClick={superAdminHandler}>
                Continue as Super Admin
              </Button>
            </div>
          </div>
          <div>
            <div className="rounded-[50px] border border-solid border-gray-300 p-3 shadow-md">
              <img src={Admin} className="h-[180px] w-[180px]" />
            </div>
            <div className="m-auto mx-2 mt-4 flex items-center justify-center">
              <Button className="w-full text-xs" onClick={adminHandler}>
                Continue as Practice Admin
              </Button>
            </div>
          </div>
        </div>
        <div className="absolute left-8 top-0 mt-10 flex items-center justify-center ">
          <Button
            onClick={handleLogoutNavigate}
            className="flex items-center justify-center"
          >
            <span className="mr-2 flex">
              {' '}
              <ArrowBackIcon fontSize="small" />
            </span>{' '}
            Back to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RoleLogin;
